import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {ThemePalette} from "@angular/material/core";

import {Subscription} from "rxjs";
import {IBusinessUnit} from "../../../business-units/models";
import {
  Config,
  getConfig,
  getSelectedBusinessUnit,
  getThemeState,
  initialConfigState,
  initialThemeState,
  Theme, toggleLoading, updateUserId
} from "../../../redux";
import {UsersService} from "../../../users/services/users/users.service";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {ToastrService} from "ngx-toastr";
import {toggleNavigating} from "../../../redux/stores/config/config.actions";
import {AppFade} from "../../../../animations/animations";
import {IAppUser} from "../../../../models";
import { DataService } from 'src/app/services/data/data.service';
import { UtilService } from 'src/app/modules/shared/services';

@Component({
  selector: 'app-approvals-navigation',
  templateUrl: './approvals-navigation.component.html',
  styleUrls: ['./approvals-navigation.component.scss'],
  animations: [AppFade()],
})
export class ApprovalsNavigationComponent {
  background: ThemePalette = undefined;
  theme: Theme = initialThemeState;

  constructor(
    public util: UtilService,
  ) {


  }

}
